module.exports = __webpack_public_path__ + "static/media/ENJ.3717bc4a.svg";